require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-co-founder-and-vp-of-education-gives-a-glimpse-of-code-fellows-past-and-future-part-2.json") })
        }
      }, "path---blog-co-founder-and-vp-of-education-gives-a-glimpse-of-code-fellows-past-and-future-part-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-co-founder-and-vp-of-education-gives-a-glimpse-of-code-fellows-past-and-future-part-2!./.cache/json/blog-co-founder-and-vp-of-education-gives-a-glimpse-of-code-fellows-past-and-future-part-2.json
// module id = 752
// module chunks = 231608221292675